import { IAccEligibility } from "./acc-elgibility.model";
import { IClassification } from "./classification.model";
import { IMedication } from "./medication.interface";
import { ITask } from "./tasks.interface";

export enum RecommendationType {
    Task = 'task',
    Classification = 'classification',
    Medication = 'medication',
    ACC_ELIGIBILITY = 'acc_eligibility'
}

export interface IRecommendations {
    tasks: ITask[],
    prescriptions: IMedication[],
    classification: IClassification[],
    accEligibility: IAccEligibility[]
}

export interface SaveTriggerPayload {
    transcript: string;
    isTranscriptionChanged: boolean;
    speechServiceTime: string;
}
